import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { TimelineModel } from '@mpt-fo/common/shared/models/timeline.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomInput } from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { DEFAULT_MODAL_KAMONA_CLASSES, DEFAULT_MODAL_WIDTH, MONIEPOINT_DESIGN_TYPE } from '@mpt-fo/common/shared/constants';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ErrorCode } from '@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model';

@Component({
	selector: 'app-username-collection',
	templateUrl: './username-collection.component.html',
	styleUrls: ['./username-collection.component.scss'],
})
export class UsernameCollectionComponent implements OnInit {
	@Input() step: TimelineModel;
	@Input() stepsArray: TimelineModel[];
	@Output() back: EventEmitter<any> = new EventEmitter();
	@Output() continue: EventEmitter<any> = new EventEmitter();
	username: CustomInput;
	form: FormGroup;
	submittingForm: boolean;
	runningModal: NzModalRef;

	constructor(private fb: FormBuilder, private auth: AuthenticationService, private modalService: ModalService) {
		this.username = new CustomInput(null, 'Username', true);
		this.form = this.fb.group({
			username: this.username.getFormGroupControl(),
		});
	}

	ngOnInit(): void {}

	next() {
		if (!this.username.validate()) {
			return;
		}
		this.step.data = this.form.value;
		this.validateOtp();
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = params?.title || 'Request failed';
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
	}

	validateOtp() {
		this.submittingForm = true;
		this.auth
			.generatePasswordOTP(this.form.value)
			.then((res) => {
				this.step.response = res;
				this.submittingForm = false;
				this.continue.emit(this.form.value);
			})
			.catch((err) => {
				this.submittingForm = false;
				if (err?.error?.code === ErrorCode.LIVELINESS_REQUIRED) {
					this.step.response = err?.error;
					this.continue.emit(this.form.value);
				} else {
					const description = StringHelper.getErrorMessageHttpErrorResponse(err);
					this.launchAlertModal({
						description,
					});
				}
			});
	}
}
